export default __webpack_public_path__ + "static/media/yellowpinata.6e6a73e5.png";